<div class="dialog--title" cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" [cdkDragFreeDragPosition]="position" (cdkDragEnded)="onDragEnded($event)">
  <h6 mat-dialog-title class="grey1">{{ data.templateId != null ? data.sysText.editTemplateActionItems_header : data.sysText.editCaseActionItems_header }}</h6>
  <!-- buttons so keyboard users can reach the info too: Material shows the tooltip on focus, and screen readers read it as the button's description -->
  <button
    type="button"
    class="button-reset info-button"
    [attr.aria-label]="data.sysText.moreInformation_ariaLabel"
    [matTooltip]="data.sysText.editActionItemsHeader_tooltip"
    [matTooltipShowDelay]="500"
    matTooltipPosition="left">
    <mat-icon class="button-icon">info_outline</mat-icon>
  </button>
  @if (isMobile$ | async) {
    <span class="spacer"></span>
    <button type="button" class="button-reset" (click)="cancel()" [attr.aria-label]="data.sysText.cancel" [disabled]="isSubmitting$ | async">
      <mat-icon class="button-icon">close</mat-icon>
    </button>
  }
</div>
<mat-dialog-content>
  <form [formGroup]="form">
    @if (data.caseId != null) {
      <div class="field-container">
        <app-select-field
          [label]="data.sysText.selectTemplateLabel"
          [control]="form.controls.template"
          [options]="data.dialogOptions.templateOptions"
          [icon]="'format_list_bulleted'"
          [info]="data.sysText.actionItemsTemplateInfo"
          [shouldCapitalize]="false"
          [showSpinner]="(templateIsLoading$ | async)"
          (emitSelectionChange)="onTemplateSelect($event)">
        </app-select-field>
        <mat-checkbox
          class="span-cell"
          [formControl]="form.controls.keepItemsWithActivity">{{ data.sysText.mergeTemplate }}
        </mat-checkbox>
      </div>
    }
  </form>
  <div cdkDropListGroup class="content-container">
    <div class="section-container">
      <h2 class="overline grey1 semibold section-title">{{ data.sysText.stages | titlecase}}</h2>
      <mat-divider class="section-header-underline"></mat-divider>
      <div class="scroll-container">
        @for (stage of data.stages; track stage; let stageIndex = $index ) {
          <div class="list-container">
            <!-- focus goes here after a remove, since the item's buttons leave with it -->
            <h3
              #stageName
              class="subtitle2 grey1"
              tabindex="-1">
              {{ stage.stageName }}
            </h3>
            <div
              cdkDropList
              [cdkDropListData]="stageActionItemsArray[stageIndex]"
              class="list"
              (cdkDropListDropped)="dropStageList($event)">
              @for (item of stageActionItemsArray[stageIndex]; track item; let actionItemIndex = $index) {
                <div
                  class="item-box"
                  cdkDrag>
                  <div class="name-container">
                    <button
                      type="button"
                      class="button-reset"
                      [attr.aria-label]="data.sysText.remove_ariaLabel"
                      (click)="onRemoveActionItem(stageIndex, actionItemIndex, stageName)">
                      <mat-icon
                        class="remove-button">
                        close
                      </mat-icon>
                    </button>
                    <!-- a toggletip: the caption is its name, the owner and description its tooltip (read as its description) -->
                    <button
                      type="button"
                      class="button-reset toggletip"
                      [matTooltip]="item.owner +  (item.description ? ' - ' + item.description : '')"
                      [matTooltipShowDelay]="500"
                      matTooltipPosition="right">
                      <span class="caption">{{ item.caption }}</span>
                    </button>
                  </div>
                  @if (item.hasActivity) {
                    <app-status-chip
                      [icon]="'warning_amber'"
                      [ngStyle]="chipStyles.warnYelBg"
                      [tooltip]="data.sysText.actionItemHasActivity"
                      [removeMargin]="true">
                    </app-status-chip>
                  }
                  <!-- keyboard alternative to dragging within a stage; aria-disabled at the ends keeps focus on the button -->
                  <button
                    #moveUpButton
                    type="button"
                    class="button-reset"
                    [attr.aria-label]="data.sysText.moveUp_ariaLabel"
                    [attr.aria-disabled]="$first || null"
                    (click)="onMoveActionItem(stageIndex, actionItemIndex, -1, moveUpButton)">
                    <mat-icon class="button-icon">arrow_upward</mat-icon>
                  </button>
                  <button
                    #moveDownButton
                    type="button"
                    class="button-reset"
                    [attr.aria-label]="data.sysText.moveDown_ariaLabel"
                    [attr.aria-disabled]="$last || null"
                    (click)="onMoveActionItem(stageIndex, actionItemIndex, 1, moveDownButton)">
                    <mat-icon class="button-icon">arrow_downward</mat-icon>
                  </button>
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div>
    <div class="section-container">
      <!-- focus goes here after an add, since the item's buttons leave with it -->
      <h2
        #actionItemsHeading
        class="overline grey1 semibold section-title"
        tabindex="-1">
        {{ data.sysText.actionItems | titlecase}}
      </h2>
      <mat-divider class="section-header-underline"></mat-divider>
      <div class="scroll-container">
        <div class="list-container">
          <div
            id="actionItemsList"
            cdkDropList
            [cdkDropListData]="availableActionItemOptions"
            class="list"
            (cdkDropListDropped)="dropActionItemList($event)">
            @for (item of availableActionItemOptions; track item; let actionItemIndex = $index) {
              <div
                class="item-box"
                cdkDrag>
                <!-- keyboard alternative to dragging an item into a stage: a menu of the stages -->
                <div class="name-container">
                  <button
                    type="button"
                    class="button-reset"
                    [matMenuTriggerFor]="stageMenu"
                    [attr.aria-label]="data.sysText.addToStage_ariaLabel">
                    <mat-icon class="button-icon">add</mat-icon>
                  </button>
                  <button
                    type="button"
                    class="button-reset toggletip"
                    [matTooltip]="item.owner +  (item.description ? ' - ' + item.description : '')"
                    [matTooltipShowDelay]="500"
                    matTooltipPosition="left">
                    <span class="caption">{{ item.caption }}</span>
                  </button>
                </div>
                @if (item.hasActivity) {
                  <app-status-chip
                    [icon]="'warning_amber'"
                    [ngStyle]="chipStyles.warnYelBg"
                    [tooltip]="data.sysText.actionItemHasActivity"
                    [removeMargin]="true">
                  </app-status-chip>
                }
                <mat-menu #stageMenu="matMenu">
                  @for (stage of data.stages; track stage.stageId; let stageIndex = $index) {
                    <button
                      mat-menu-item
                      class="grey1"
                      (click)="onAddActionItem(actionItemIndex, stageIndex, actionItemsHeading)">
                      <span>{{ stage.stageName }}</span>
                    </button>
                  }
                </mat-menu>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  @let isSubmitting = isSubmitting$ | async;
  @if (!isSubmitting && this.form.errors?.msError) {
    <mat-error class="mse-form-error caption">{{ this.form.errors?.msError }}</mat-error>
  }
  @if (!(isMobile$ | async)) {
    <button
      mat-stroked-button
      class="button"
      color="accent"
      [disabled]="isSubmitting"
      (click)="cancel()">
      {{ data.sysText.cancel }}
    </button>
  }
  <!-- save keeps focus while saving: showProgress lays the spinner over its label, disabledInteractive keeps it focusable, and the guard blocks clicks -->
  <button
    mat-stroked-button
    class="button"
    color="accent"
    [disabled]="isSubmitting"
    disabledInteractive
    [showProgress]="isSubmitting"
    [attr.aria-label]="isSubmitting ? data.sysText.submitting_ariaLabel : null"
    (click)="!isSubmitting && save()">
    {{ data.sysText.save }}
    <mat-spinner progressIndicator diameter="30" color="accent"></mat-spinner>
  </button>
</mat-dialog-actions>

